import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotComics from './components/HotComics';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function Home() {
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "免费韩国漫画在线阅读_最新高清韩漫下拉式观看-尾巴漫画网",
    "description": "尾巴漫画网提供海量免费韩国漫画在线畅读，每日更新最新高清韩漫，支持下拉式观看模式。",
    "url": "https://www.weibamanhua.com/",
    "isPartOf": {
      "@type": "WebSite",
      "name": "尾巴漫画网",
      "url": "https://www.weibamanhua.com/"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "尾巴漫画网的韩漫是免费的吗？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "是的，尾巴漫画网上的所有韩国漫画都是完全免费的。我们致力于为韩漫爱好者提供海量高清韩漫资源，每日更新的最新韩漫同样免费开放。"
        }
      },
      {
        "@type": "Question",
        "name": "什么是下拉式观看模式？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "下拉式观看模式是一种专为手机和电脑优化的阅读方式，无需翻页，只需向下滚动即可连续阅读漫画内容，带来极致流畅的阅读体验。"
        }
      },
      {
        "@type": "Question",
        "name": "网站多久更新一次韩漫？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "尾巴漫画网坚持每日更新，确保读者能够第一时间追到最新的韩国漫画章节。"
        }
      },
      {
        "@type": "Question",
        "name": "可以在手机上阅读吗？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "当然可以！尾巴漫画网完美适配手机、平板和电脑等多种设备，随时随地畅读韩漫。"
        }
      },
      {
        "@type": "Question",
        "name": "如何找到我想看的韩漫？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "您可以通过首页的热门推荐、最新更新区域快速找到热门韩漫，也可以通过分类浏览功能按恋爱言情、奇幻冒险等类型筛选。"
        }
      },
      {
        "@type": "Question",
        "name": "需要注册账号才能阅读吗？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "不需要注册账号。尾巴漫画网所有韩漫均可直接在线阅读，无需注册或登录。"
        }
      }
    ]
  };

  return (
    <>
      <SchemaOrg schema={homeSchema} />
      <SchemaOrg schema={faqSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <HotComics />
        <CategoryNav />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}